import {
  EMPLOYEE_PERSONNEL_LEVEL_CHANGE_FETCHING,
  EMPLOYEE_PERSONNEL_LEVEL_CHANGE_SUCCESS,
  EMPLOYEE_PERSONNEL_LEVEL_CHANGE_FAILED
} from "../actions/types";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_PERSONNEL_LEVEL_CHANGE_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case EMPLOYEE_PERSONNEL_LEVEL_CHANGE_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };
    case EMPLOYEE_PERSONNEL_LEVEL_CHANGE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
